/**
 * 全局基础方法库 bll
 * 版本: 0.0.3
 */

import * as jsonBll from './json';

/**
 * 日期方法
 */
const date = {
  /**
   * 时间戳转换为时间
   * @param {*} ns 时间戳 new Date().getTime()
   */
  timeLocal(ns) {
    return new Date(parseInt(ns) * 1000)
      .toLocaleString()
      .replace(/:\d{1,2}$/, ' ');
  },

  /**
   * 日期加减数字
   * @param {string} strInterval 参数 年(y)、月(m)、日(d)、小时(h)、分(n)、秒(s)、周(w)、季度(q)
   * @param {number} len 加减数字
   * @param {*} dtTmp  初始日期时间
   * @returns  new Date().add("d",1)
   */
  add(strInterval, len, dtTmp) {
    switch (strInterval) {
      case 's':
        return new Date(Date.parse(dtTmp) + 1000 * len);
      case 'n':
        return new Date(Date.parse(dtTmp) + 60000 * len);
      case 'h':
        return new Date(Date.parse(dtTmp) + 3600000 * len);
      case 'd':
        return new Date(Date.parse(dtTmp) + 86400000 * len);
      case 'w':
        return new Date(Date.parse(dtTmp) + 86400000 * 7 * len);
      case 'q': // 季度
        return new Date(
          dtTmp.getFullYear(),
          dtTmp.getMonth() + len * 3,
          dtTmp.getDate(),
          dtTmp.getHours(),
          dtTmp.getMinutes(),
          dtTmp.getSeconds()
        );
      case 'm': // 月
        return new Date(
          dtTmp.getFullYear(),
          dtTmp.getMonth() + len,
          dtTmp.getDate(),
          dtTmp.getHours(),
          dtTmp.getMinutes(),
          dtTmp.getSeconds()
        );
      case 'y': // 年
        return new Date(
          dtTmp.getFullYear() + len,
          dtTmp.getMonth(),
          dtTmp.getDate(),
          dtTmp.getHours(),
          dtTmp.getMinutes(),
          dtTmp.getSeconds()
        );
    }
    return dtTmp;
  },
  /**
   * 时间秒数格式输出 秒/分/时/天
   * @param {number} timer 需转换的时间秒数
   * @param {array} tag 显示的标签['天', '小时', '分', '秒']
   * @param {number} len 默认输出标签第4位
   * @param {string} _move 余标识默认..
   * @returns 返回文本 天，小时，分钟，秒
   */
  sec(timer, tag, len = 4, _move) {
    tag = tag || ['天', '小时', '分', '秒'];
    // console.log('_move', typeof _move, _move);
    _move = typeof _move != 'undefined' ? _move : '..';
    let str = '';

    /** 分钟60秒 */
    let _minute = 60,
      /** 小时 */
      _hour = _minute * 60,
      _day = _hour * 24;
    // _month = _day * 30;
    // _year = _month * 12;

    // 计算出相差天数
    let days = Math.floor(timer / _day);
    if (days > 1) {
      str = days + tag[0];
    }

    // 计算出小时数
    let leave1 = timer % _day; // 计算天数后剩余的毫秒数
    let hours = Math.floor(leave1 / _hour);

    if (len > 1) {
      str += hours > 1 ? hours + tag[1] : '';
    } else {
      str += hours > 1 ? _move : '';
      return str;
    }

    // 计算相差分钟数
    let leave2 = leave1 % _hour; // 计算小时数后剩余的毫秒数
    let minutes = Math.floor(leave2 / _minute);
    if (len > 2) {
      str += minutes > 1 ? minutes + tag[2] : '';
    } else {
      str += minutes > 1 ? _move : '';
      return str;
    }

    // 计算相差秒数
    let leave3 = leave2 % _minute; // 计算分钟数后剩余的毫秒数
    let seconds = Math.round(leave3);
    if (len > 3) {
      str += seconds > 1 ? seconds + tag[3] : '';
    } else {
      str += seconds > 1 ? _move : '';
    }
    return str;
  },
  /**
   * 时间戳间隔时间
   * @param {*} ns 间隔时间秒
   * @param {*} i 取出的显示层级(1-5)
   * 返回 年/月/日/时/分
   */
  expire(ns, i = 5) {
    let result = '',
      minute = 60,
      hour = minute * 60,
      day = hour * 24,
      month = day * 30,
      year = month * 12;

    if (ns / year >= 1 && i) {
      let temp = ~~(ns / year);
      result += temp + '年';
      ns -= temp * year;
      i--;
    }
    if (ns / month >= 1 && i) {
      let temp = ~~(ns / month);
      result += temp + '月';
      ns -= temp * month;
      i--;
    }
    if (ns / day >= 1 && i) {
      let temp = ~~(ns / day);
      result += temp + '天';
      ns -= temp * day;
      i--;
    }
    if (ns / hour >= 1 && i) {
      let temp = ~~(ns / hour);
      result += temp + '时';
      ns -= temp * hour;
      i--;
    }
    if (ns / minute >= 1 && i) {
      result += ~~(ns / minute) + '分钟';
      i--;
    }
    return result;
  },

  /**
   * 日期间隔
   * @param {*} start 开始日期
   * @param {*} end 结束日期
   * @param {number} len 默认输出标签第3位
   * @param {Array} tag 时间描述标签 ['年', '个月', '天']
   * @returns json 支持闰年,2月天数处理
   */
  range(start, end, len = 3, tag) {
    // let r = start.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})/);
    tag = tag || ['年', '个月', '天'];
    // tag = tag || ['年', '个月', '天', '小时', '分', '秒'];
    start = start || new Date();
    end = end || new Date();

    if (typeof start === 'string') {
      // console.log('start:' + start)
      start = toDate(start);
    }

    if (typeof end === 'string') {
      // console.log('end:' + end)
      end = toDate(end);
    }

    // console.log(d);

    let resp = {
      text: '',
      /** 是否是闰年 */
      leapYear: false,
      y: 0,
      m: 0,
      d: 0
    };

    //  console.log(end);
    let yearNow = end.getFullYear();
    let monthNow = end.getMonth() + 1;
    let dayNow = end.getDate();

    /** 大月， 用于计算天，只在年月都为零时，天数有效 */
    let largeMonths = [1, 3, 5, 7, 8, 10, 12],
      /** 上一个月的月份 */
      lastMonth = monthNow - 1 > 0 ? monthNow - 1 : 12,
      /** 当前日期的上一个月多少天 */
      daysOFMonth = 0;

    if ((yearNow % 4 === 0 && yearNow % 100 !== 0) || yearNow % 400 === 0) {
      // 是否闰年， 用于计算天，只在年月都为零时，天数有效
      resp.leapYear = true;
    }

    if (largeMonths.indexOf(lastMonth) > -1) {
      daysOFMonth = 31;
    } else if (lastMonth === 2) {
      // 处理2月闰年天数
      daysOFMonth = resp.leapYear ? 29 : 28;
    } else {
      daysOFMonth = 30;
    }

    resp.y = yearNow - start.getFullYear();
    resp.m = monthNow - start.getMonth() - 1;
    resp.d = dayNow - start.getDate();
    // resp.h = end.getHours() - start.getHours();
    // resp.mm = end.getMinutes() - start.getMinutes();
    // resp.s = end.getSeconds() - start.getSeconds();

    if (resp.d < 0) {
      resp.d = resp.d + daysOFMonth; //借一个月
      resp.m--;
    }

    if (resp.m < 0) {
      // 借一年 12个月
      resp.y--;
      resp.m = resp.m + 12; //
    }

    let i = -1,
      _value = '';

    for (let _k in resp) {
      i++;
      if (i > len) {
        break;
      }
      switch (_k) {
        case 'y':
          if (resp.y > 0) {
            _value += resp.y + tag[0];
          }
          break;
        case 'm':
          if (resp.m > 0 && resp.m < 12) {
            _value += resp.m + tag[1];
          }
          break;
        case 'd':
          if (resp.d > 0) {
            _value += resp.d + tag[2];
          }
          break;
        // 时间算法用 sec 代替
        // case 'h':
        //   if (resp.h > 0) {
        //     _value += resp.h + tag[3];
        //   }
        //   break;
        // case 'mm':
        //   if (resp.mm > 0) {
        //     _value += resp.mm + tag[4];
        //   }
        //   break;
        // case 's':
        //   if (resp.s > 0) {
        //     _value += resp.s + tag[5];
        //   }
        //   break;
      }
    }
    // resp.value 替换为 resp.text
    resp.text = _value;
    return resp;
  }
};

/**
 * 时差计算输出调用range
 * @param {*} start 开始时间toDate，默认
 * @param {*} end 结束时间toDate，默认 new Date()
 * @param {number} len sec输出长度最大4
 * @param {string} _move sec余标识
 * @param {Array} tag sec时间描述标签
 * @returns 返回 {sec:'0时间差秒',tip: '提示剩余/过期',text:'时间内容'}
 */
date.gap = (start, end, len = 4, _move, tag) => {
  start = start || new Date();
  end = end || new Date();

  if (typeof start === 'string') {
    // console.log('start:' + start)
    start = toDate(start);
  }

  if (typeof end === 'string') {
    // console.log('end:' + end)
    end = toDate(end);
  }

  let result = {
    /** 时差秒 */
    sec: (end.getTime() - start.getTime()) / 1000,
    tip: '',
    text: ''
  };

  if (end > start) {
    let _rg = date.range(start, end);
    result = {
      exceed: false,
      /** 时差秒 */
      sec: (end.getTime() - start.getTime()) / 1000,
      tip: '剩余',
      ..._rg
    };
  } else {
    let _rg = date.range(end, start);
    result = {
      exceed: true,
      /** 时差秒 */
      sec: (start.getTime() - end.getTime()) / 1000,
      tip: '过期',
      ..._rg
    };
  }
  // result.expire = date.expire(result.sec);
  result.day = date.sec(result.sec, tag, len, _move);
  // result.text = result.value;
  // delete result.value;
  // Date.parse(dateTime.replace(/-/gi, "/"))

  // let minute = 1000 * 60;
  // let hour = minute * 60;
  // let day = hour * 24;
  // let month = day * 30; //1个月

  // let yearTemp = diffValue / (12 * month);
  // let monthTemp = diffValue / month;
  // let weekTemp = diffValue / (7 * day);
  // let dayTemp = diffValue / day;
  // let hourTemp = diffValue / hour;
  // let minTemp = diffValue / minute;

  // if (yearTemp >= 1) {
  //   result.text = parseInt(yearTemp) + ' 年';
  //   return result;
  // } else if (monthTemp >= 1) {
  //   result.text = parseInt(weekTemp) + ' 个月';
  //   return result;
  // } else if (weekTemp >= 1) {
  //   result.text = '' + parseInt(weekTemp) + ' 个星期';
  // } else if (dayTemp >= 1) {
  //   result.text = '' + parseInt(dayTemp) + ' 天';
  // } else if (hourTemp >= 1) {
  //   result.text = '' + parseInt(hourTemp) + ' 个小时';
  // } else {
  //   if (minTemp < 1) {
  //     minTemp = 1;
  //   }
  //   result.text = '' + parseInt(minTemp) + ' 分钟';
  // }
  return result;
};

/**
 * 时间差显示 调用gap.start
 * @param {*} dateTime  时间字符串
 * @param {number} len 时间取的长度
 * @param {Array} tag 时间描述标签
 * @returns  多少天或者小时或分钟 前
 */
date.diff = (dateTime, len = 6, tag) => {
  return date.gap(dateTime, null, len, tag).text + '前';
};

/**
 * 数组方法
 */
const array = {
  /**
   * 删除数组 splice
   * @param {*} arr 源数组
   * @param {*} value 删除的内容
   * @param {*} length 删除内容位置后的数量
   */
  del(arr, value, length = 1) {
    let _index = arr.indexOf(value);
    if (_index > -1) {
      //删除从指定位置deletePos开始的指定数量deleteCount的元素，数组形式返回所移除的元素
      arr.splice(_index, length);
    }
    return _index;
  },
  /**
   * 查找内容所在的序号位置,没有为 -1
   * @param {*} arr 数组[]
   * @param {*} value 内容
   * @param {boolean} last 默认从前查询
   * indexOf() 从数组的开头（位置0）开始向后查找。
   * lastIndexOf() 从数组的末尾开始向前查找。
   */
  find(arr, value, last = false) {
    if (last) {
      return arr.lastIndexOf(value);
    } else {
      return arr.indexOf(value);
    }
  },
  /**
   * 数组去重复添加,返回新数组
   * @param {*} data 原始数组
   * @param {*} arr 需要添加去重复数组
   * @returns es5方式,建议es6
   */
  unique(data, arr) {
    data = data || [];
    for (let i = 0; i < arr.length; i++) {
      if (data.indexOf(arr[i]) == -1) {
        data.push(arr[i]);
      }
    }
    return data;
  },

  /**
   * 数组元素置顶
   * @param {*} arr 原数组
   * @param {*} index 需置换的元素序号
   * @param {*} to 置换到的位置，默认0
   * @returns 返回删除的对象
   */
  swap: (arr, index, to = 0) => {
    // console.log('swap:' + index, arr[index], arr);
    // 从to位置插入新的对象
    arr.splice(to, 0, arr[index]);
    // console.log('swap:' + to, arr);
    // 从当前历史位置删除
    arr.splice(index + 1, 1);
    // arr.unshift(arr[index]);
    // index = index + 1;
    // arr.splice(index, 1);
    return arr;
    // arr.unshift(arr[index]);
    // index = index + 1;
    // arr.splice(index, 1);
    // return arr;
  },
  /**
   * 创建数组排序方法,支持中文 localeCompare
   * @param {string} sortBy 排序字段名
   * @param {string} type 排序字段的类型 int,date,string
   * @param {boolean} desc 默认降序
   * @returns data.sort(Function)
   */
  sort: (sortBy, type, desc = true) => {
    let _order = desc ? '<' : '>';
    // 返回排序方法
    let _fun;
    switch (type) {
      case 'int':
      case 'int32':
      case 'int64':
      case 'long': //数字类型
        _order = `return a.${sortBy} ${_order} b.${sortBy}?1:-1`;
        _fun = new Function('a', 'b', _order);
        break;
      case 'date': //日期类型
        _order = `let _a=a['${sortBy}']; _a=_a?new Date(_a).getTime():0; let _b=b['${sortBy}']; _b=_b?new Date(_b).getTime():0; return _a ${_order} _b?1:-1`;
        _fun = new Function('a', 'b', _order);
        break;
      default:
        //string 字符串
        _order = desc ? '_a.localeCompare(_b)' : '_b.localeCompare(_a)';
        _order = `let _a=a['${sortBy}']||''; let _b=b['${sortBy}']||'';  return ${_order}`;
        _fun = new Function('a', 'b', _order);
        break;
    }
    // console.log(type, desc, _order);
    return _fun;
  }
};

/**
 * 判断参数是否是数组其中之一 oneOf
 * @param {*} value 参数
 * @param {*} arr 数组
 */
array.test = (value, arr) => {
  return array.find(arr, value) > -1 ? true : false;
};

/**
 * 按生日计算年龄
 * @param {*} start 生日
 * @param {*} _year 年后缀
 * @param {*} _mn 月后缀
 * @param {*} _day 天后缀
 */
const getAge = (start, _year = '岁', _mn = '个月', _day = '天') => {
  return date.range(start, null, _year, _mn, _day);
};

/**
 * 判断值类型 typeof
 * @param {*} val 初始值
 * @returns 返回对象类型小写,与typeof不同
 */
const getType = (val) => {
  return Object.prototype.toString
    .call(val)
    .replace(']', '')
    .split(' ')[1]
    .toLowerCase();
};

/**
 * 检查对象是否为空或者内容是空
 * @param {*} data 任意对象，包括json
 */
const isNull = (data) => {
  let _rb = data === null;
  // console.log(_rb, getType(data), typeof data);
  // console.log(typeof data);
  switch (getType(data)) {
    case 'undefined':
      _rb = true;
      break;
    case 'string':
      _rb = data.length < 1;
      break;
    // case 'date':
    //   _rb = data === null;
    //   break;
    // case "number":
    //    _rb = (data === 0);//取消数字判断为空
    //    break;
    case 'object':
      _rb = data === null;
      if (!_rb) {
        _rb = isArray(data);
        if (_rb) {
          // 验证数组内容是否为空
          _rb = data.length < 1;
        } else {
          if (jsonBll.test(data)) {
            // 验证Json 是否为空
            _rb = jsonBll.isNull(data);
          }
        }
      }
      break;
    case 'boolean':
      _rb = !data;
      break;
    case 'array':
      _rb = data.length > 0;
      break;
    // default:
    //   _rb = false;
  }

  return _rb;
};

/**
 * 判断是否是数组
 * @param {*} obj 对象
 */
const isArray = (obj) => {
  // return Object.prototype.toString.call(obj).toLowerCase() === '[object array]'
  // return obj && !(obj.propertyIsEnumerable('length')) && typeof obj === 'object' && typeof obj.length === 'number';
  return obj instanceof Array;
};

/**
 * 判断是否为数字
 * @param {*} str 文本内容
 */
const isInt = (str) => {
  let re = /^[0-9]{1,20}$/;
  return re.test(str);
};

/**
 * 校验手机号码：以1开头，长度为11位即可
 * @param {*} str 手机号码
 * @param {*} regex 手机号码验证规则 /^1[3456789][0-9]{9}$/
 */
const isPhone = (str, regex = /^1[3456789][0-9]{9}$/) => {
  return regex.test(str);
  // return str.length === 11 && /^1+\d{10}$/.test(str);
};

/**
 * 判断字符串是否布尔值
 * @param {*} str 字符串
 */
const isBool = (str) => {
  return /^true$/i.test(str);
};

/**
 * 测试是否支持 h5存储
 */
const isStorage = () => {
  try {
    return 'localStorage' in window && window['localStorage'] !== null;
  } catch (e) {
    return false;
  }
};

/**
 * 是否是h5浏览器或者mp小程序,可用window对象
 */
const isWeb = () => {
  return window ? true : false;
};

/**
 * 判断是否微信端浏览
 * @param {*} ua window.navigator.userAgent.toLowerCase()
 */
const isWeChat = (ua) => {
  let _rb = false;
  try {
    ua = ua || window.navigator.userAgent.toLowerCase();
    _rb = /micromessenger/i.test(ua);
  } catch (e) {
    console.log(e);
  }
  return _rb;
};

/**
 * replace 替换正则格式化
 * 201910061220 转为 2019-10-06 12:20
 * @param {*} str 数字内容
 * @param {*} reg 正则格式
 * @param {*} code 输出格式描述
 */
const toReg = (
  str,
  reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/,
  code = '$1-$2-$3 $4:$5'
) => {
  return str.replace(reg, code);
};

/**
 * 转换显示格式 内容部分隐藏为*
 * @param {*} str 内容
 * @param {*} reg 正则
 * @param {*} code 保留符号
 */
const toHide = (str, reg = /(\d{3})(\d{4})(\d{4})/, code = '$1****$3') => {
  return str.replace(reg, code);
};

/**
 * 下划或横线字符串转大写驼峰格式
 * @param {*} str 原字符串
 * @param {*} regex 下划或横线转换规则
 * @returns 大写驼峰形式
 */
const toCamel = (str, regex = /([^_])(?:_+([^_]))/g) => {
  // 取出首字母转换
  let _temp = str.slice(0, 1);
  // console.log(_temp, str);
  str = _temp.toUpperCase() + str.substr(1);
  return str.replace(regex, function ($0, $1, $2) {
    //   console.log($0, $1, $2);
    return $1 + $2.toUpperCase();
  });
};

/**
 * 驼峰转小写下划或横线格式
 * @param {*} str 原文
 * @param {*} mark 横线-或者下划线
 * @returns
 */
const toCamelLine = (str, mark = '-') => {
  let _temp = str.replace(/[A-Z]/g, function (match) {
    return mark + match.toLowerCase();
  });
  if (_temp.slice(0, 1) === mark) {
    //如果首字母是大写，执行replace时会多一个_，这里需要去掉
    _temp = _temp.slice(1);
  }
  return _temp;
};

/**
 * 转为 MAC 格式ff-dd-ee-rr-tt
 * @param {*} mac
 */
const toMac = (mac) => {
  let _str = '';
  for (let i = 0; i < 6; i++) {
    _str += '-' + mac.substr(0, 2);
    mac = mac.substr(2);
  }
  return _str.substr(1);
};

/**
 * 时间字符串转为时间 兼容safari
 * @param {*} str 时间字符串 转为/格式
 * @returns 返回 输出国际标准时间（ISO），减少了8个小时
 */
const toDate = (str) => {
  // console.log(str, new Date(str));
  //let DateStr = this.replace(/-/g, '/'); // 兼容safari,进行转移
  return new Date(str.replace(/-/g, '/'));
  //str = str.replace(/-/g, '/');
  //return new Date(str);
  //return new Date(Date.parse(str.replace(/-/g, '/')));
};

/**
 * 字符转金额,与money对应使用
 * @param {*} str 字符串
 * @returns  返回浮动数字parseFloat
 */
const toFloat = (str) => {
  return parseFloat(trim(str).replace(/[^\d\.-]/g, ''));
};

/**
 * 金额格式化并补位数
 * @param {*} priceNum 初始金额数字
 * @param {number} len 保留小数位数
 * @param {string} dir 默认补全小数位
 * @returns 不进行4舍5入法
 */
const toDecimal = (priceNum, len, dir = 'f') => {
  if (!priceNum || !len) {
    return false;
  }

  priceNum = parseFloat(priceNum, 10);
  len = parseInt(len, 10);

  if (dir === 'f') {
    // 补小数位
    let intNumStr = priceNum.toString().split('.')[0];
    let decimalNumStr = priceNum.toString().split('.')[1] || '00';

    if (decimalNumStr.length < 2) {
      decimalNumStr += '0';
    }

    return intNumStr + '.' + decimalNumStr.substring(0, len);
  } else {
    return priceNum.toFixed(len);
  }
};

/**
 * 数字转换为金额显示
 * @param {*} s 初始数字
 * @param {*} n 小数位数
 * @param {*} symbol 符号"￥"
 * @returns ￥千位，小数位
 */
const toMoney = (s, n, symbol = '￥') => {
  n = n || 2;
  s = toRound(s, n);
  s = s.toString();
  // if (s > 0) {
  //if (/[^0-9\.]/.test(s))
  //    return "0.00";
  //if (s == null || s == "null" || s == "")
  //    return "0.00";

  // 分解小数
  let _num = s.split('.');
  s = _num[0] + ',';

  //s = s.toString().replace(/^(\d*)$/, '$1.');
  //s = (s + '00').replace(/(\d*\.\d\d\d)\d*/, '$1');
  //s = s.replace('.', ',');

  // console.log(s);

  let re = /(\d)(\d{3},)/;
  while (re.test(s)) {
    s = s.replace(re, '$1,$2');
  }

  s = s.substring(0, s.length - 1);
  // console.log(s);
  if (n > 0) {
    s += '.';
    let _h = _num[1] || '';
    for (let i = _h.length; i < n; i++) {
      // 补0
      _h += '0';
    }

    s += _h;
  }

  // s = s.replace(/,(\d\d)$/, '.$1');
  // console.log(s);

  return symbol + s;
};

/**
 * 四舍五入法
 * @param {*} val 初始值
 * @param {*} num 转换位数
 * @returns 解决 toFixed 遇到坑
 */
const toRound = (val, num = 2) => {
  return Math.round(val * Math.pow(10, num)) / Math.pow(10, num);
};

/**
 * 加减法  解决计算精度不准确问题的解决办法
 * @param {*} value 初始数字
 * @param {*} arg 加减数字
 * @returns js浮点数
 */
const addFloat = (value, arg) => {
  let r1, r2, m;
  try {
    r1 = arg.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = value.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (arg * m + value * m) / m;
};

/**
 * 乘法浮点运算
 * @param {*} arg1 乘数
 * @param {*} arg2 乘数
 * @param {number} d 保留的位数
 * @returns 解决小数
 */
const mul = (arg1, arg2, d) => {
  let r1 = arg1.toString(),
    r2 = arg2.toString(),
    m,
    resultVal;

  // console.log('mul', arguments);

  m =
    (r1.split('.')[1] ? r1.split('.')[1].length : 0) +
    (r2.split('.')[1] ? r2.split('.')[1].length : 0);
  resultVal =
    (Number(r1.replace('.', '')) * Number(r2.replace('.', ''))) /
    Math.pow(10, m);

  if (d) {
    resultVal = Number(resultVal.toFixed(parseInt(d)));
  } else {
    resultVal = Number(resultVal);
  }

  return resultVal;
};

/**
 * 清除前后空格
 * @param {*} str 初始字符串
 */
const trim = (str) => {
  if (str) {
    return str.replace(/(^\s*)|(\s*$)/g, '');
  }
};

/**
 * 字符串（单引号非标json等）转换为Jaon
 * @param {*} str 传入字符串
 * @returns 调用 String.toJson()
 */
const parse = (str) => {
  return new Function('return ' + trim(str))();
};

/**
 * 年度第几周
 * @param {Date} _dt 查询日期
 * @returns
 */
const getYearWeek = (_dt) => {
  let d1 = new Date(_dt);
  let d2 = new Date(_dt);
  d2.setMonth(0);
  d2.setDate(1);
  let rq = d1 - d2;
  let days = Math.ceil(rq / (24 * 60 * 60 * 1000));
  let num = Math.ceil(days / 7);
  return num;
};

/**
 * 当月第几周
 * @param {Date} _dt 查询日期
 * @returns
 */
const getMonthWeek = (_dt) => {
  /**
   * a = d = 当前日期
   * b = 6 - w = 当前周的还有几天过完(不算今天)
   * a + b 的和在除以7 就是当天是当前月份的第几周
   */
  let _args = {
    y: _dt.getFullYear(), //年
    m: _dt.getMonth() + 1, //月份
    d: _dt.getDate(), //日
    w: _dt.getDay() //周几
  };
  if (_args.w == 0) {
    _args.w = 7;
  }
  return Math.ceil((_args.d + 6 - _args.w) / 7);
};

/**
 * 时间格式化为字符串
 * @param {*} rule 格式化
 * @param {Date} _dt 初始时间格式差8小时注意用/ toDate(yyyy-MM-dd)
 * @param {Array} week 星期[日，一，二]
 * @returns
 * format("yyyy-MM-dd HH:mm:ss:S",new Date())
 * 年(y) 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、豪秒(S)、周(W)、周(w)、年度第几周(E)、当月第几周(e)、季度(q)
 */
const format = (rule, _dt, week) => {
  if (!_dt) {
    throw new Error('format.value is null');
  }

  let _type = _dt instanceof Date;

  if (!_type) {
    throw new Error(
      'format.value not is Date ' + getType(_dt) + ',' + typeof _dt
    );
  }

  // 默认规则
  rule = rule || 'yyyy-MM-dd HH:mm:ss';

  // 默认星期
  week = week || ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

  // console.log(_dt.getHours(), _dt);
  // _dt = new Date(_dt.toLocaleDateString('chinese', { hour12: false }));
  // console.log(_dt.getHours(), _dt);

  let _day = _dt.getDay();
  let _args = {
    'M+': _dt.getMonth() + 1,
    'd+': _dt.getDate(),
    'h+': _dt.getHours() % 12 === 0 ? 12 : _dt.getHours() % 12, // 小时
    'H+': _dt.getHours(),
    'm+': _dt.getMinutes(),
    's+': _dt.getSeconds(),
    S: _dt.getMilliseconds(), // 毫秒
    'W+': week[_day],
    'w+': '日一二三四五六'.charAt(_day), // 周
    'q+': Math.floor((_dt.getMonth() + 3) / 3), // 季度
    'E+': getYearWeek(_dt), //年度第几周
    'e+': getMonthWeek(_dt) //当月第几周
  };

  //console.log(_dt.getHours(), _args);

  if (/(y+)/.test(rule)) {
    rule = rule.replace(
      RegExp.$1,
      (_dt.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  }
  for (let i in _args) {
    let n = _args[i];
    if (new RegExp('(' + i + ')').test(rule)) {
      rule = rule.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? n : ('00' + n).substr(('' + n).length)
      );
    }
  }
  return rule;
};

/**
 * 生成伪随机数
 * @param {*} n 取出的最小位数
 * @param {*} m 取出的最大位数 建议大于9999
 * @returns
 */
const random = (n, m) => {
  return parseInt(Math.random() * (m - n + 1)) + n;
};

/**
 * 生成随机字符串码 (不易重复)
 * @param {*} max 取出位数
 * @param {*} arr 自定义数组,默认不填
 * @returns 返回大写
 */
const randomCode = (max, arr) => {
  let str = '';
  arr = arr || [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'J',
    'K',
    'L',
    'M',
    'N',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
  ];

  for (let i = 0; i < max; i++) {
    let range = Math.round(Math.random() * (arr.length - 1)) + 1;
    //  console.log('sss:' + i, range);
    range = arr[range];
    if (range) {
      str += range;
    } else {
      str += arr[i];
    }
  }

  return str;
};

/**
 * 立即执行动态js代码
 * @param {*} code return 代码
 * @param {array,string} pars 附加传入的参数名或数组
 * @param {*} value pars 传入参数值
 * @returns  new Function syntax
 */
const run = (code, pars, value) => {
  try {
    // 执行代码(传入类库名)
    return new Function(pars, code)(value);
  } catch (e) {
    throw new Error('run syntax', e);
  }
};

/**
 * 构造函数，来自funCode
 * @param {*} code 函数代码字符串
 * @param {*} pars 附加参数
 * @returns Function
 */
const fun = function (code, pars) {
  let resp;
  try {
    resp = funCode(code, pars);
    return new Function(resp[1], resp[0]);
  } catch (e) {
    console.error('fun syntax', resp);
    throw new Error('fun syntax', e);
  }
};

/**
 * 解析函数代码,支持ed6语法 正则
 * @param {*} code function 函数代码字符串
 * @param {*} pars 附加传入参数
 * @returns {array} [code,pars]
 */
const funCode = function (code, pars) {
  let isEs = false; // 是否是es6语法

  // function ) {
  // let regexp = /function([\s\S]*?)\)[^>]*{/gi;

  let _code = trim(code);
  //console.log('fu', _code);
  // 正则提取 function(之间的内容){
  let regexp = /function[^>]*\((.*?)\)[^>]*{/;
  // 正则取出参数字符串
  let _arr = regexp.exec(_code);
  //console.log('funa', _arr);
  if (!_arr) {
    // 没有提前到，就提前es6 (之间)=>{}
    regexp = /\((.*?)\)[^>]*\=\>[^>]*\{/;
    _arr = regexp.exec(_code);
    isEs = true;
  }
  // console.log('funa', _arr);
  // 取出传入参数
  let _pars = [];
  if (_arr) {
    // 分割传入参数
    _pars = trim(_arr[1]);
    _pars = _pars ? _pars.split(',') : [];
  }
  // console.log('funp', _pars);
  // 去除参数与符号
  if (isEs) {
    // 没有提前到，就提前es6 (之间 =>{
    _code = _code.replace(/(\(.*?\=\>.*?{)/, '');
    //console.log('fun6', _code);
  } else {
    _code = _code.replace(/(function.*?{)/, '');

    // let regexp = /function[^>]*{(.*?)[}*$]/g;
    // let _body = regexp.exec(_code);
    // _code = _body[1];
  }
  // 去除尾部符号
  _code = _code.replace(/(}*$)/g, '');
  // console.log('func', _code);

  // console.log('function', _pars, _arr);

  // 判断是否为es6 格式， 取出脚本内容 排除式[^}]*

  // regexp = isEs ? /=>[^>]*{([\s\S]*?)}/gi : /function[^>]*{([\s\S]*?)}$/gi;
  // regexp = isEs ? /=>[^>]*{([\s\S]*?)}/gi : /^((function)?:\/\/)[^\s]+/;
  // let _bady = regexp.exec(code);

  // return [];

  if (_code) {
    _code = trim(_code);

    // 组合附加传入参数
    switch (getType(pars)) {
      case 'string':
        _pars.push(pars);
        break;
      case 'array':
        _pars = _pars.concat(pars);
        break;
    }

    // console.log('fun:', _pars);
    return [_code, _pars];
    //return new Function(_pars,trim(_bady[1]))
    // return run(trim(_bady[1]),_pars)
  }
};

/**
 * 按标准位数不够，初始值前补0
 * @param {*} num 初始值
 * @param {*} n 标准位数
 */
const zeroFill = (num, n) => {
  return (
    Array(n > ('' + num).length ? n - ('' + num).length + 1 : 0).join(0) + num
  );
};

export {
  date,
  array,
  getAge,
  getType,
  getYearWeek,
  getMonthWeek,
  isNull,
  isArray,
  isInt,
  isPhone,
  isBool,
  isStorage,
  isWeb,
  isWeChat,
  toReg,
  toHide,
  toMac,
  toDate,
  toFloat,
  toDecimal,
  toMoney,
  toRound,
  addFloat,
  mul,
  trim,
  parse,
  format,
  random,
  randomCode,
  run,
  fun,
  funCode,
  zeroFill,
  toCamel,
  toCamelLine
};
